<template>
  <div class="admin-page">
    <!-- ── 页头 ───────────────────────────────────────────── -->
    <div class="page-head">
      <div class="head-text">
        <h1>爱豆充值</h1>
        <p>为用户手工补发爱豆，仅限所管辖学校的学生</p>
      </div>
    </div>

    <div class="panel recharge-panel">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px" class="recharge-form">
        <el-form-item label="选择用户" prop="userId">
          <el-select
            v-model="form.userId"
            filterable
            remote
            reserve-keyword
            placeholder="输入用户昵称搜索"
            :remote-method="searchUsers"
            :loading="searchLoading"
            style="width: 100%;"
          >
            <el-option
              v-for="item in userOptions"
              :key="item.id"
              :label="item.nickname + ' (' + item.schoolName + ')'"
              :value="item.id"
            />
          </el-select>
          <div class="form-hint">
            <i class="el-icon-info" /> 只能搜到你所管辖学校的学生。
          </div>
        </el-form-item>

        <el-form-item label="当前爱豆">
          <div class="balance-box">
            <span class="balance-num">{{ toBean(currentBalance) }}</span>
            <span class="balance-unit">爱豆</span>
            <span class="balance-sub">约 ¥{{ Number(currentBalance || 0).toFixed(2) }}</span>
          </div>
        </el-form-item>

        <el-form-item label="充值爱豆" prop="beanAmount">
          <el-input-number v-model="form.beanAmount" :min="1" :max="1000000" :step="10" />
          <div class="form-hint">
            实际到账 {{ form.beanAmount }} 爱豆，按 ¥1 = {{ beanRate }} 爱豆记账。
          </div>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="充值备注（选填）" />
        </el-form-item>

        <el-form-item class="form-actions">
          <el-button type="primary" class="primary-btn" :loading="submitting" @click="submitForm">
            确认充值
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { rechargeBalance } from '@/api/recharge'
import { getUserList } from '@/api/user'
import { toBean, getBeanRate } from '@/utils/bean'

export default {
  name: 'RechargeBalance',
  data() {
    return {
      submitting: false,
      form: {
        userId: null,
        amount: 10,
        // 界面以「爱豆」为单位输入，提交前换算回元 —— 后端与库的口径始终是元
        beanAmount: 100,
        remark: ''
      },
      rules: {
        userId: [{ required: true, message: '请选择用户', trigger: 'change' }],
        beanAmount: [{ required: true, message: '请输入充值爱豆数', trigger: 'blur' }]
      },
      userOptions: [],
      searchLoading: false,
      currentBalance: '0.00',
      records: []
    }
  },
  computed: {
    beanRate() {
      return getBeanRate()
    }
  },
  methods: {
    toBean(yuan) {
      return toBean(yuan)
    },
    searchUsers(keyword) {
      if (keyword) {
        this.searchLoading = true
        getUserList({ keyword, size: 20 }).then(res => {
          this.userOptions = res.data.list || []
          this.searchLoading = false
        })
      } else {
        this.userOptions = []
      }
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }
        // 界面输入的是爱豆，提交给后端前换回元 —— 库里与后端口径一行都没改
        const yuan = this.form.beanAmount / getBeanRate()
        this.$confirm(`确定为该用户充值 ${this.form.beanAmount} 爱豆吗？`, '提示', {
          type: 'warning'
        }).then(() => {
          this.submitting = true
          rechargeBalance({
            userId: this.form.userId,
            amount: yuan,
            remark: this.form.remark
          }).then(() => {
            this.$message.success('充值成功')
            this.form = {
              userId: null,
              beanAmount: 100,
              remark: ''
            }
            this.currentBalance = '0.00'
            this.userOptions = []
            this.submitting = false
          }).catch(() => {
            this.submitting = false
          })
        }).catch(() => {})
      })
    },
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleString()
    }
  },
  watch: {
    'form.userId'(val) {
      if (val) {
        const user = this.userOptions.find(u => u.id === val)
        if (user) {
          this.currentBalance = user.balance || '0.00'
        }
      } else {
        this.currentBalance = '0.00'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.recharge-panel {
  padding: 24px 26px 8px;
}

.recharge-form {
  max-width: 560px;
}

.balance-box {
  display: flex;
  align-items: baseline;
  gap: 6px;
  padding: 8px 14px;
  background: var(--rose-50);
  border-radius: var(--r-md);
}

.balance-num {
  font-size: 22px;
  font-weight: 700;
  color: var(--rose-600);
  line-height: 1.2;
}

.balance-unit {
  font-size: 13px;
  color: var(--rose-600);
}

.balance-sub {
  font-size: 12px;
  color: var(--ink-400);
  margin-left: auto;
}

.form-hint {
  font-size: 12px;
  color: var(--ink-400);
  line-height: 1.6;
  margin-top: 4px;
}

.form-actions {
  margin-top: 6px;
  padding-top: 18px;
  border-top: 1px solid var(--ink-100);
}
</style>
